<template>
  <div class="cards-resumo1" aria-label="Resumo das notícias por status">
    <template v-if="isCoordenacao">
      <button v-for="filtro in FILTROS_STATUS_NOTICIA_COORDENACAO" :key="filtro.valor" type="button" class="card-resumo"
        :class="[filtro.classe, { selecionado: filtroAtivo === filtro.valor }]"
        @click="$emit('selecionar', filtro.valor)">
        <span class="rotulo">{{ filtro.rotulo }}</span>
        <strong>{{ contagens[filtro.valor] ?? 0 }}</strong>
        <small>{{ filtro.descricao }}</small>
      </button>
    </template>
    
    <template v-else>
      <button type="button" class="card-resumo total" :class="{ selecionado: filtroAtivo === 'TODAS' }"
        @click="$emit('selecionar', 'TODAS')">
        <span class="rotulo">Total recebido</span>
        <strong>{{ resumoNoticias.total }}</strong>
        <small>Todas as notícias</small>
      </button>
      <button type="button" class="card-resumo pendente" :class="{ selecionado: filtroAtivo === 'PENDENTE' }"
        @click="$emit('selecionar', 'PENDENTE')">
        <span class="rotulo">Aguardando análise</span>
        <strong>{{ resumoNoticias.pendentes }}</strong>
        <small>Requerem uma decisão</small>
      </button>
      <button type="button" class="card-resumo aprovada" :class="{ selecionado: filtroAtivo === 'ACEITA' }"
        @click="$emit('selecionar', 'ACEITA')">
        <span class="rotulo">Aceitas</span>
        <strong>{{ resumoNoticias.aceitas }}</strong>
        <small>Notícias autorizadas</small>
      </button>
      <button type="button" class="card-resumo reprovada"
        :class="{ selecionado: filtroAtivo === 'REJEITADA' }" @click="$emit('selecionar', 'REJEITADA')">
        <span class="rotulo">Rejeitadas</span>
        <strong>{{ resumoNoticias.rejeitadas }}</strong>
        <small>Notícias recusadas</small>
      </button>
    </template>
  </div>
</template>

<script setup>
import { FILTROS_STATUS_NOTICIA_COORDENACAO } from "@/constants/noticias";

defineProps({
  isCoordenacao: {
    type: Boolean,
    default: false,
  },
  // { TODAS: n, ENVIADA: n, PROGRAMADA: n, PUBLICADA: n, RECUSADA: n }
  contagens: {
    type: Object,
    default: () => ({}),
  },
  resumoNoticias: {
    type: Object,
    default: () => ({ total: 0, pendentes: 0, aceitas: 0, rejeitadas: 0 }),
  },
  filtroAtivo: {
    type: String,
    default: "TODAS",
  },
});

defineEmits(["selecionar"]);
</script>

<style scoped>
/* Mesmo visual dos cards de resumo da Central PREX */
.cards-resumo1 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 14px;
  width: 100%;
  margin-bottom: 20px;
}

.card-resumo {
  position: relative;
  width: 100%;
  min-height: 120px;
  padding: 16px 18px;
  overflow: hidden;
  border: 1px solid #e2dce9;
  border-radius: 14px;
  text-align: left;
  background: #fff;
  box-shadow: 0 5px 18px rgba(44, 27, 70, 0.06);
  cursor: pointer;
  transition:
    transform 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}

.card-resumo::after {
  position: absolute;
  right: -22px;
  bottom: -36px;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.08;
  content: "";
}

.card-resumo:hover,
.card-resumo.selecionado {
  transform: translateY(-2px);
  border: 1px solid white;
  box-shadow: 0 8px 22px rgba(44, 27, 70, 0.1);
}

.card-resumo.total {
  color: #5b3fa8;
}

.card-resumo.total:hover,
.card-resumo.total.selecionado {
  color: white;
  background-color: #5b3fa8;
}

.card-resumo.pendente {
  color: #a56a00;
}

.card-resumo.pendente:hover,
.card-resumo.pendente.selecionado {
  color: white;
  background-color: #a56a00;
}

.card-resumo.programada {
  color: #1565c0;
}

.card-resumo.programada:hover,
.card-resumo.programada.selecionado {
  color: white;
  background-color: #1565c0;
}

.card-resumo.aprovada {
  color: #278159;
}

.card-resumo.aprovada:hover,
.card-resumo.aprovada.selecionado {
  color: white;
  background-color: #278159;
}

.card-resumo.reprovada {
  color: #c24451;
}

.card-resumo.reprovada:hover,
.card-resumo.reprovada.selecionado {
  color: white;
  background-color: #c24451;
}

.card-resumo .rotulo,
.card-resumo small {
  display: block;
}

.card-resumo .rotulo {
  color: inherit;
  font-size: 0.78rem;
  font-weight: 700;
}

.card-resumo strong {
  display: block;
  margin: 6px 0 2px;
  font-size: 1.85rem;
  line-height: 1;
}

.card-resumo small {
  color: inherit;
  opacity: 0.7;
  font-size: 0.72rem;
}

@media (max-width: 900px) {
  .cards-resumo1 {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .cards-resumo1 {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .cards-resumo1 {
    display: grid;
    grid-template-columns: 1fr;
  }
}
</style>
